<template>
  <!-- gis采集APP版本20240902 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="12">
            <a-form-item label="应用版本名称">
              <a-input v-model="query.versionName" placeholder="请输入应用版本名称" allow-clear />
            </a-form-item>
          </a-col>

          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="addOrUpdateHandle()" v-action:add>新增</a-button>
              <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()" v-action:del>删除</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table rowKey="id" :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }" :data-source="list"
      :columns="columns" :loading="dataListLoading" :pagination="pagination" @change="pageChange">
      <span slot="action" slot-scope="text, record">
        <a @click="edit(record)" v-action:edit>编辑</a>
        <!-- <a @click="deleteSelectRow(record)" v-action:del style="margin-left: 15px;color: red;">删除</a> -->

      </span>
    </a-table>
    <a-modal title="操作" style="top: 20px" :width="800" v-model="addOrUpdateVisible" @ok="handleOk"
      @cancel="handleCancel">

      <a-form class="log-form" :form="addOrUpdateForm">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="应用版本号(整数)">
          <a-input-number :formatter="limitNumber" :parser="limitNumber" :min="1"
            v-decorator="['versionNumber', { rules: [{ type: 'number', pattern: '/[^\d]/g', required: true, message: '请输入整数' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="应用版本名称">
          <a-input placeholder="应用版本名称"
            v-decorator="['versionName', { rules: [{ required: true, message: '请输入应用版本名称' }] }]" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="应用下载地址">
          <a-input placeholder="应用下载地址"
            v-decorator="['downloadAddress', { rules: [{ required: true, message: '请输入应用下载地址' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="应用更新描述">
          <a-textarea placeholder="应用更新描述" v-decorator="['applicationDesc']" :auto-size="{ minRows: 4 }" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
          <a-textarea placeholder="备注" v-decorator="['remark']" :auto-size="{ minRows: 4 }" />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'

const columns = [
  {
    title: '应用名称',
    dataIndex: 'applicationName',
    width: 150,

  },
  {
    title: '应用版本号',
    dataIndex: 'versionNumber',
    width: 120,

  },


  {
    title: '应用版本名称',
    dataIndex: 'versionName',
    width: 150,

  },
  {
    title: '应用更新描述',
    dataIndex: 'applicationDesc',
  },
  {
    title: '应用下载地址',
    dataIndex: 'downloadAddress'
  },

  {
    title: '备注',
    dataIndex: 'remark',
    width: 120,
  },

  {
    title: '创建时间',
    dataIndex: 'createTime',
  },
  {
    title: '操作',
    dataIndex: 'action',
    align: 'center',

    width: 150,
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  mixins: [mixinViewModule],
  name: 'LogList',
  data () {
    return {
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: total => `共 ${total} 条记录`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100']
      },
      currentId: '',
      queryUrl: '/gis-manager/user/version/page',
      deleteUrl: '/gis-manager/user/version/remove/',
      addOrUpdateUrl: '/gis-manager/user/version/edit',
      query: {
        versionName: ''
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      columns,
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      selectedRows: []
    }
  },

  created () { },
  methods: {
    // 重置
    resetList () {
      if (this.query.sysType) {
        const params = {
          sysType: this.query.sysType
        }
        this.query = params
      } else {
        this.query = {}
      }
      this.selectedRows = []

      this.queryList()
    },
    queryList () {
      const params = {
        orderColumn: this.orderColumn,
        orderType: this.orderType,
        ...this.query
      }

      params.page = this.pagination.current

      params.limit = this.pagination.pageSize


      this.dataListLoading = true
      this.$http
        .get(this.queryUrl, {
          params
        })
        .then(({ data }) => {
          this.dataListLoading = false
          if (this.needPage) {
            this.list = data.list || []
            this.selectedRows = []
            this.pagination.total = data.total ? parseInt(data.total) : 0
            if (data.total > 0) {
              this.isadd = false
            } else {
              this.isadd = true
            }
          } else {
            this.list = data
          }
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    deleteSelectRow () {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        return this.$message.warn('请选择要删除的数据')
      }
      const _this = this
      this.selectedRows = this.selectedRows.map(str => parseInt(str, 10));
      console.log(_this.selectedRows, _this.deleteUrl)
      this.$confirm({
        title: `删除提醒`,
        content: `您确认要删除选择的${this.selectedRows.length}条数据吗?`,
        okText: '确认',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          _this.$http.post(_this.deleteUrl,
            _this.selectedRows
          ).then((res) => {
            if (res.code === 0) {
              _this.$message.success(`共删除${_this.selectedRows.length}条数据`)
              _this.selectedRows = []
              _this.resetList()
              _this.queryList()
            }
          }).catch(() => { })
        },
        onCancel () {
          _this.selectedRows = []
          _this.$message.info('已取消删除')
        }
      })
    },
    // 正则不能输入中文
    checkData (rule, value, callback) {
      if (value) {
        if (/[\u4E00-\u9FA5]/g.test(value)) {
          callback(new Error('应用版本号(必须是整数)只能输入英文或数字、特殊符号!'))
        } else {
          callback()
        }
      }
      callback()
    },

    handleOk (e) {
      e.preventDefault()
      this.addOrUpdateForm.validateFields((err, values) => {
        if (values.status == true) {
          values.status = '1'
        } else if (values.status == false) {
          values.status = '2'
        }
        if (!err) {
          this.$http[!this.currentId ? 'post' : 'put'](this.addOrUpdateUrl, this.query.sysType ? {
            id: this.currentId,
            sysType: this.query.sysType,
            ...values
          } : {
            id: this.currentId,
            ...values
          })
            .then((res) => {
              if (res.code === 0) {
                this.addOrUpdateVisible = false
                this.queryList()
                return this.$message.success(res.message)
              }
            })
            .catch(() => { })
        }
      })
    },
    statusChange (e) {
      if (e.status == '2') {
        e.status = '1'
      } else {
        e.status = '2'
      }
      this.$http.put(this.addOrUpdateUrl, e).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.message)
          this.resetList()
        } else {
          this.$message.error('修改失败')
        }
      })
    },
    detailInfo (record) {
      this.detailForm = { ...record }
    },
    edit (record) {
      record.status = record.status == 1 ? true : false
      this.isUpdate = true
      this.currentId = record.id
      this.addOrUpdateForm.resetFields()
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.addOrUpdateForm.setFieldsValue(record)
      })
    },
    // handleOk() {

    // },
    handleCancel () { }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>
